import {Button, ButtonProps, ComponentWithAs, IconProps} from '@chakra-ui/react';

import {CrownIcon} from './icons';

interface ChangeRoleButtonProps extends ButtonProps {
  title: string;
  icon: ComponentWithAs<'svg', IconProps>;
}

export const ChangeRoleButton = ({title, icon: Icon, ...props}: ChangeRoleButtonProps) => (
  <Button
    variant="ghost"
    gap="2"
    px="3.5"
    fontSize="sm"
    fontWeight="600"
    bgColor="white"
    color="gray.800"
    borderColor="gray.800"
    borderWidth="1px"
    rounded="0.5rem"
    _active={{borderWidth: '3px', borderColor: 'green.400', fontWeight: 800}}
    _disabled={{
      border: 0,
      bgColor: 'gray.400',
      color: 'gray.500',
      cursor: 'not-allowed',
      _active: {fontWeight: '600'},
      _hover: {bgColor: 'var(--chakra-colors-gray-400) !important'},
      '& > svg': {opacity: 0.3},
    }}
    {...props}
  >
    {props.isActive && !props.isDisabled ? <Icon /> : <CrownIcon />} {title}
  </Button>
);
